import React from 'react';
import { Card, CardContent } from './ui/card';
import {
  Sparkles,
  Image,
  Wifi,
  Star,
  Video,
  Film,
  Sun,
  Monitor,
  Layout
} from 'lucide-react';
import { upgrades } from '../data/mock';

const Upgrades = () => {
  const iconMap = {
    Sparkles: Sparkles,
    Image: Image,
    Wifi: Wifi,
    Star: Star,
    Video: Video,
    Film: Film,
    Sun: Sun,
    Monitor: Monitor,
    Layout: Layout
  };

  return (
    <section id="upgrades" className="section-padding bg-gray-950 relative overflow-hidden">
      {/* Background Elements */}
      <div className="absolute inset-0 grid-pattern opacity-20" />
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-cyan-500/5 rounded-full blur-3xl" />

      <div className="relative z-10 max-w-6xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="accent-line mx-auto mb-6" />
          <h2 className="section-title text-white mb-4">Upgrades & Add-Ons</h2>
          <p className="subtitle max-w-2xl mx-auto">
            Enhance your photo booth experience with premium add-ons tailored to your event.
          </p>
        </div>

        {/* Upgrades Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {upgrades.map((upgrade, index) => {
            const IconComponent = iconMap[upgrade.icon];
            return (
              <Card
                key={upgrade.id}
                className="bg-gray-900/50 border-gray-800 hover:border-cyan-500/30 transition-all duration-300 group cursor-pointer"
              >
                <CardContent className="p-6">
                  <div className="flex items-start space-x-4">
                    <div className="p-3 bg-gray-800 rounded-lg text-cyan-400 group-hover:bg-cyan-500/10 transition-colors">
                      {IconComponent && <IconComponent className="w-6 h-6" />}
                    </div>
                    <div>
                      <h3 className="text-lg font-semibold text-white mb-2 font-display">
                        {upgrade.name}
                      </h3>
                      <p className="text-gray-400 text-sm leading-relaxed">
                        {upgrade.description}
                      </p>
                    </div>
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Contact CTA */}
        <div className="text-center mt-12">
          <p className="text-gray-400 mb-4">
            Want to customize your package? We're happy to create a custom quote.
          </p>
          <a
            href="#contact"
            className="inline-flex items-center text-cyan-400 hover:text-cyan-300 font-medium transition-colors"
          >
            Contact us for pricing
            <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Upgrades;
